window._paq = window._paq || [];
delete window._trlk;

// Without consent nothing may be queued, because matomo.js replays the whole queue once it loads.
let active = false;
let loaded = false;

export const activate = () => {
  if (active) {
    return;
  }
  active = true;

  if (!loaded) {
    loaded = true;
    (function () {
      var u = "//www.nordkirche.de/piwik/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '220']);
      var d = document, g = d.createElement('script'), h = d.getElementsByTagName('head')[0];
      g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = u + 'matomo.js'; h.appendChild(g);
    })();
    _paq.push(['enableLinkTracking']);
  }
  trackPageView();
}


// Best effort: once matomo.js is loaded, its link tracking keeps running until the next page load.
export const deactivate = () => {
  active = false;
}

export const trackPageView = () => {
  if (active && !window._trlk) {
    //set tracking lock to block multiple tracking requests
    //for example browser-back triggers tracking twice
    window._trlk = true;
    //wait a little for page title to have a chance to update
    setTimeout(() => {
      //unset tracking lock
      delete window._trlk
      if (active) {
        doTrackPageView();
      }
    }, 500);
  }
}

const doTrackPageView = () => {
  //matomo doesn't update the title and url, if trackPageView is tracked multiple times without a refresh
  _paq.push(['setDocumentTitle', document.title]);
  _paq.push(['setCustomUrl', window.location.href]);
  _paq.push(['trackPageView']);
}

export const trackEvent = params => {
  if (!active) {
    return;
  }
  //delay as in trackPageView to have events send synchronously
  setTimeout(() => {
    if (active) {
      doTrackEvent(params);
    }
  }, 500);
}

const doTrackEvent = params => {
  params.unshift('trackEvent');
  _paq.push(params);
}

export const isMatomoCookie = cookie => {
  return cookie.replace(/^ +/, "").startsWith("_pk_");
}
